
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/bank-transfers/reference",
      function () {
        return require("private-next-pages/docs/bank-transfers/reference.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/bank-transfers/reference"])
      });
    }
  